import { CoreMenuItem } from "app/back-office/vuexy-theme/@vuexy-core/types";

export class AppMenu {
  items: CoreMenuItem[];

  constructor(init?: Partial<AppMenu>) {
    Object.assign(this, init);
  }
}
